import { useBuilderStore } from '../../store/builderStore';
import { formatPrice, DEFAULT_CURRENCY } from '@printtat/shared';

const SurfaceOptions = () => {
  const currentSurface = useBuilderStore((s) => s.currentSurface);
  const pricingConfig = useBuilderStore((s) => s.pricingConfig);
  const surfaceOptionSelections = useBuilderStore((s) => s.surfaceOptionSelections);
  const setSurfaceOption = useBuilderStore((s) => s.setSurfaceOption);

  const currency = pricingConfig?.currency ?? DEFAULT_CURRENCY;
  const optionDefs = pricingConfig?.surfaceOptions?.[currentSurface];
  if (!optionDefs || optionDefs.length === 0) return null;

  return (
    <div className="flex items-center gap-2 -mb-4 relative z-1 px-2 pt-4 pb-1.5 bg-white/90 backdrop-blur-sm rounded-lg border border-gray-200 shadow-sm -translate-y-4">
      {optionDefs.map((def) => {
        const selected = surfaceOptionSelections[currentSurface]?.[def.key] ?? def.default;

        return (
          <div key={def.key} className="flex items-center gap-1.5">
            <span className="text-[10px] text-gray-500 font-medium">{def.label}</span>
            <div className="flex items-center gap-0.5">
              {def.choices.map((choice) => (
                <button
                  key={choice.value}
                  onClick={() => setSurfaceOption(currentSurface, def.key, choice.value)}
                  className={`px-2 py-0.5 text-[10px] rounded-md transition-colors ${
                    selected === choice.value
                      ? 'bg-gray-900 text-white'
                      : 'text-gray-600 hover:bg-gray-100 bg-gray-50'
                  }`}
                >
                  {choice.label}
                  {choice.price > 0 && (
                    <span className="ml-1 opacity-70">+{formatPrice(choice.price, currency)}</span>
                  )}
                </button>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export { SurfaceOptions };
